import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const AccessibilityPopupStyles = makeStyles()((theme: Theme) => ({
  closeButton: {
    float: 'right',
  },
  closeIcon: {
    padding: '0',
    float: 'right',
    marginLeft: 'auto',
  },
  content: {
    padding: '0rem 1.25rem',
    [theme.breakpoints.down('md')]: {
      padding: '0rem 1.5rem',
      '& p, & li': {
        fontSize: '14px',
      },
    },
  },
  subContent: {
    margin: '0rem 0rem 1.25rem',
    [theme.breakpoints.down('md')]: {
      margin: '0rem 0rem 1rem',
    },
  },
  footer: {
    padding: '1rem 1.25rem',
    [theme.breakpoints.down('md')]: {
      padding: '1rem 1.5rem 1.5rem 1.5rem',
    },
  },
  headingContent: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  list: {
    border: 'none',
    background: 'none',
    boxShadow: 'none',
    listStyleType: 'disc',
    listStylePosition: 'inside',
    padding: '0',
  },
  listItem: {
    display: 'list-item',
    textAlign: 'start',
    padding: '0rem 1rem',
  },
}));
